<!-- workspace.html -->
<div class="workspace-wrapper">
  <header class="app-top-banner" #bannerAnchor>
    <div class="banner-content">
      <svg class="app-logo" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
      </svg>
      <span class="banner-title">{{ bannerText() }}</span>
    </div>

    @if (generatedLetter(); as letter) {
      <div class="doc-generated-chip-row">
        <div class="doc-generated-chip" aria-label="Letter generated for case {{letter.caseNo}}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
          <span class="chip-text">
            Case #<strong>{{letter.caseNo}}</strong>
            <span class="chip-divider">|</span>
            <span class="chip-path">{{letter.filePath}}</span>
          </span>
          <!-- <button class="chip-open-btn" (click)="openLetter()" [attr.title]="tooltipTexts.openGeneratedLetter" aria-label="Open generated letter in Word">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
            <span>Open in Word</span>
          </button> -->
          <button class="chip-copy-btn" (click)="copyPath(letter.filePath)" [attr.title]="tooltipTexts.copyGeneratedPath" aria-label="Copy file path to clipboard">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            Copy Path
          </button>
          <button class="chip-close-btn" (click)="closeBanner()" aria-label="Close">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    }

    <div class="banner-user-block" (clickOutside)="closeMenu()">
      <button class="user-chip" type="button" (click)="toggleMenu()" [attr.aria-label]="'User menu for ' + username()">
        <span class="user-avatar">{{ userInitial() }}</span>
        <span class="banner-username">{{ username() }}</span>
        <svg class="chevron" [class.open]="menuOpen()" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
      </button>

      @if (menuOpen()) {
        <div class="user-menu" aria-label="User menu">
          <a class="menu-item" [href]="helpDocumentationUrl" target="_blank" rel="noopener noreferrer">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
            </svg>
            Help &amp; Support
          </a>
          <button class="menu-item" type="button" (click)="logout()" aria-label="Logout">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16,17 21,12 16,7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Logout
          </button>
        </div>
      }
    </div>
  </header>

  <div class="workspace-layout">
    <!-- Left Column -->
    <div class="column left-column">
      <div class="panel-wrapper search-cases-panel">
        <app-search-cases></app-search-cases>
      </div>
    </div>

    <!-- Middle Column -->
    <div class="column middle-column">
      <div class="panel-wrapper search-results-panel" #searchResultsAnchor>
        <app-search-results></app-search-results>
        @if (caseService.isSearching()) {
          <app-loader variant="overlay" message="Searching cases..." />
        }
      </div>
    </div>

    <!-- Right Column -->
    <div class="column right-column">
      <div class="panel-wrapper edit-fields-panel">
        <app-edit-fields></app-edit-fields>
        @if (actionService.isGeneratingLetter()) {
          <app-loader variant="overlay" message="Generating letter..." />
        }
      </div>
    </div>
  </div>

  <footer class="app-footer">
    {{ footerText }}
  </footer>
</div>